import { all } from "redux-saga/effects";
import { watchMobile } from "./mobile";

export default function* rootSaga() {
    yield all([watchMobile()]);
}
